// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"732":"41f1aaea","977":"79c2d6c2"}[chunkId] + ".chunk.js";
};